import React from 'react';

class Loader extends React.Component {
  render() {
    return (
      <section className="cmx-pageloader">
        <div className="loadingio-spinner-ellipsis-v15ybwg2y1f">
            <div className="ldio-k3gn3536d5m">
                <div></div><div></div><div></div><div></div><div></div>
            </div>
        </div>
      </section>
    )
  }
}
export default Loader;
